import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import "../../styles/phone-icon.css";

const PhoneIcon = () => {
  return (
    <a href="tel:+40741383836" className="phone_float" aria-label="Suna acum">
      <FontAwesomeIcon icon={faPhone} className="phone-icon" />
    </a>
  );
};

export default PhoneIcon;
